module.exports = __webpack_public_path__ + "media/private_estate.80cdeb16.jpg";